import { Control, Controller, RegisterOptions } from "react-hook-form";
import { NGCheckbox } from "../../../../newcomponents/checkbox";
import React from "react";

interface CheckboxOption {
  label: React.ReactNode;
  value: string;
  disabled?: boolean;
}

interface FormNGCheckboxGroupProps {
  name: string;
  control: Control<any>;
  rules?: RegisterOptions;
  options: CheckboxOption[];
  noneValue?: string; // Default: "none"
}

export const FormNGCheckboxGroup = ({ 
  name, 
  control, 
  rules, 
  options,
  noneValue = "none"
}: FormNGCheckboxGroupProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => {
        const currentValue = field.value || noneValue;
        
        return (
          <>
            {options.map((option) => (
              <NGCheckbox
                key={option.value}
                checked={currentValue === option.value}
                onChange={(checked) => {
                  if (checked) {
                    // Set to this option's value
                    field.onChange(option.value);
                  } else if (currentValue === option.value) {
                    // If unchecking the currently selected option, set to none
                    field.onChange(noneValue);
                  }
                  // If unchecking a different option, do nothing (it's already unchecked)
                }}
                isDisabled={option.disabled}
              >
                {option.label}
              </NGCheckbox>
            ))}
          </>
        );
      }}
    />
  );
};